






























































































































import { Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';
import * as E from '@/enums';

import AxAPI from '@/api';

type Group = I.AxZone;
type Group1 = I.CodeData;
type Item = I.AccountDetail;

type GroupListPanel = I.AxGroupListPanel<Group, Item>;
type PageInfo = I.AccountPageInfo;

type DataItem = U.DataItem<unknown, State>;
type DataStore = U.DataStore<unknown, never>;

const DataStore = U.DataStore;

type UpdateItemParam = I.AccountUpdateReq;

interface AccountPair {
  idx: number;
  menuName: string;
}

class State {
  name: string;
  code: string;
  etc: string;
  password: string;
  selected: AccountPair[];
  itemStatus: E.ItemStatus;
  privType: string;
  zone: string;
  location: string;
  ip: string;
  locking: boolean;
  passwordChang: boolean;
  zoneList: I.ZoneData[];
  companycodeFilterList: I.CodeData[];
  deptcodebFilterList: I.CodeData[];

  constructor() {
    this.name = '' as never;
    this.code = '' as never;
    this.etc = '' as never;
    this.password = '' as never;
    this.selected = [];
    this.itemStatus = E.ItemStatus.None;
    this.privType = '' as never;
    this.zone = '' as never;
    this.location = '' as never;
    this.ip = '' as never;
    this.zoneList = [];
    this.companycodeFilterList = [];
    this.deptcodebFilterList = [];
    this.locking = false;
    this.passwordChang = false;
  }
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  panel!: GroupListPanel;
  pageInfo!: PageInfo;
  dataItem!: DataItem;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  async getPageInfo() {
    const result = await this.API.call.account.get();
    console.log('pageInfo', result);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async updateItem(item: UpdateItemParam) {
    console.log('item', item);
    const result = await this.API.call.account.accountUpdate(item);
    console.log('result', result);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '메뉴 테이블',
      store: new DataStore<AccountPair>({
        headers: {
          menuName: '메뉴명'
        }
      }),
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }
}

@Component
class GroupPanelHandler extends BaseClass {
  onListGroupChanged(group?: Group) {
    if (!this.pageInfo || !group) return;

    if (this.panel.items) {
      this.panel.items = this.pageInfo.listZone;
    }
  }

  onListItemChanged(item?: Item) {
    console.log('items', item);
    this.dataItem.state.location = '';
    if (item) {
      const selectedAccount1 = this.pageInfo.listMenu.filter((menu, idx, source) =>
        item.listIdx.includes(menu.idx)
      );

      console.log('selelecaccount1', selectedAccount1);
      console.log('store', this.dataItem.store);

      const listAccount = this.pageInfo.listMenu;

      this.dataItem.state.code = item.code;
      this.dataItem.state.name = item.name;
      this.dataItem.state.selected = selectedAccount1;
      this.dataItem.state.etc = item.etc;
      this.dataItem.state.itemStatus = E.ItemStatus.Update;
      this.dataItem.state.privType = item.privType;
      this.dataItem.state.location = item.location;
      this.dataItem.state.ip = item.ip;
      this.dataItem.state.locking = item.locking;
      this.dataItem.state.passwordChang = false;
      this.dataItem.state.zoneList = item.listZone;
      this.dataItem.state.companycodeFilterList = item.listCompanyCode;
      this.dataItem.state.deptcodebFilterList = item.listDeptCodeB;
      this.dataItem.store.setItems(listAccount);

      console.log('dataItem', this.dataItem.state);
    } else {
      this.dataItem.state = new State();
      this.dataItem.state.itemStatus = E.ItemStatus.None;
    }
  }

  onListAddClicked() {
    this.dataItem.state = new State();
    this.dataItem.state.name = '';
    this.dataItem.state.code = '';
    this.dataItem.state.etc = '';
    this.dataItem.state.selected = [];
    this.dataItem.state.locking = true;
    this.dataItem.state.passwordChang = false;
    this.dataItem.state.itemStatus = E.ItemStatus.New;
    this.dataItem.state.privType = '10';

    const listAccount = this.pageInfo.listMenu;
    this.dataItem.store.setItems(listAccount);
    this.OnTypeSelectChange();
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  panel: GroupListPanel = {
    groups: [],
    items: [],
    group: -1,
    item: -1
  };

  listAccessType: Group1[] = [
    { code: '10', name: 'Normal' },
    { code: '50', name: 'Administrator' },
    { code: '100', name: 'Engineer' }
  ];

  pageInfo = {} as PageInfo;
  zoneCode = 0;
}

const Handlers = Mixins(ApiHandler, DataItemHandler, GroupPanelHandler);

@Component
export default class ConfigAccount extends Mixins(BaseData, Handlers) {
  async prepare() {
    const pageInfo = await this.getPageInfo();
    if (pageInfo) {
      this.pageInfo = pageInfo;
      console.log('리스트', this.pageInfo.listAccount);
      this.panel.items = this.pageInfo.listAccount;
    }
  }

  async onSaveClicked() {
    const { itemStatus } = this.dataItem.state;
    if (itemStatus === E.ItemStatus.None) return;

    const updateFlag =
      itemStatus === E.ItemStatus.New ? E.EUpdateFlag.Insert : E.EUpdateFlag.Update;

    const account = this.dataItem.state.code;
    const accountName = this.dataItem.state.name;
    const accountDesc = this.dataItem.state.etc;
    const privType = this.dataItem.state.privType;
    const location = this.dataItem.state.location;
    const ip = this.dataItem.state.ip;
    const listIdx = this.dataItem.state.selected.map(x => x.idx);
    const listCompanyCode = this.dataItem.state.companycodeFilterList;
    const listDeptCodeA = this.dataItem.state.deptcodebFilterList;
    const listDeptCodeB = this.dataItem.state.deptcodebFilterList;
    const listZone = this.dataItem.state.zoneList;
    let locking = false;
    if (this.dataItem.state.locking === true) {
      locking = false;
    } else {
      locking = true;
    }

    console.log('location', account);
    let accountPassword = '';

    if (account === '') {
      await this.showErrorModal('오류', '아이디을 입력 해주세요.');
      return;
    } else if (listIdx.length === 0) {
      await this.showErrorModal('오류', '메뉴을 선택 해주세요.');
      return;
    }

    if (updateFlag === E.EUpdateFlag.Insert) {
      const isExist = this.pageInfo.listAccount.some(x => x.code === account);
      if (isExist) {
        await this.showErrorModal('오류', '이미 존재하는 아이디입니다.');
        return;
      }
    }

    const title = '확인';
    const message =
      itemStatus === E.ItemStatus.New ? '입력한 계정을 추가할까요?' : '선택한 계정을 수정할까요?';
    const buttons = ['네', '아니오'];

    const confirm = await this.showConfirmModal(title, message, buttons);
    if (confirm !== 0) return;

    //--비밀번호 변경화면 신규나 암호 변경시 저장 루틴
    if (this.dataItem.state.passwordChang === true || updateFlag === E.EUpdateFlag.Insert) {
      type PasswordParams = { title: string; param: I.DataParam };
      const dialogParams = new I.DialogParam<PasswordParams>('AxAccountChangePasswordDialog', {
        title: '암호 입력',
        param: {
          items: [this.dataItem.state],
          headers: [{ text: '이름', value: 'name', align: 'start' }],
          selected: [this.dataItem.state],
          callback: async () => {
            if (dialogParams.props.param.selected[0].password !== '') {
              accountPassword = dialogParams.props.param.selected[0].password;
              this.setLoading(true);
              const result = await this.updateItem({
                updateFlag,
                account,
                accountPassword,
                accountName,
                accountDesc,
                privType,
                location,
                ip,
                locking,
                listIdx,
                listCompanyCode,
                listDeptCodeA,
                listDeptCodeB,
                listZone
              });

              this.setLoading(false);
              if (!result) return;

              this.onUpdated(result, updateFlag);
            }
          }
        }
      });
      await this.showDialog(dialogParams);
    } else {
      //--수정이나 암호 변경없는 저장
      accountPassword = '';
      this.setLoading(true);
      const result = await this.updateItem({
        updateFlag,
        account,
        accountPassword,
        accountName,
        accountDesc,
        privType,
        location,
        ip,
        locking,
        listIdx,
        listCompanyCode,
        listDeptCodeA,
        listDeptCodeB,
        listZone
      });

      this.setLoading(false);
      if (!result) return;

      this.onUpdated(result, updateFlag);
    }
  }

  async onDeleteClicked() {
    const { code, name, etc, selected, itemStatus } = this.dataItem.state;
    if (itemStatus === E.ItemStatus.None) return;

    const updateFlag = E.EUpdateFlag.Delete;

    const confirm = await this.showConfirmModal('확인', '선택된 아이템을 삭제할까요?', [
      '네',
      '아니오'
    ]);
    if (confirm !== 0) return;

    const account = this.dataItem.state.code;
    const accountName = this.dataItem.state.name;
    const accountDesc = this.dataItem.state.etc;
    const privType = this.dataItem.state.privType;
    const location = this.dataItem.state.location;
    const ip = this.dataItem.state.ip;
    const listIdx = this.dataItem.state.selected.map(x => x.idx);
    const listCompanyCode = this.dataItem.state.companycodeFilterList;
    const listDeptCodeA = this.dataItem.state.deptcodebFilterList;
    const listDeptCodeB = this.dataItem.state.deptcodebFilterList;
    const listZone = this.dataItem.state.zoneList;
    const locking = false;
    const accountPassword = '';

    this.setLoading(true);
    const result = await this.updateItem({
      updateFlag,
      account,
      accountPassword,
      accountName,
      accountDesc,
      privType,
      location,
      ip,
      locking,
      listIdx,
      listCompanyCode,
      listDeptCodeA,
      listDeptCodeB,
      listZone
    });
    this.setLoading(false);
    if (!result) return;

    this.onUpdated(result, E.EUpdateFlag.Delete);
  }

  async onUpdated(result: Item, updateFlag: E.EUpdateFlag) {
    if (!this.pageInfo) return;
    const prevGroup = this.panel.group;
    this.panel.groups = [];
    this.panel.items = [];

    await this.prepare();
    await this.$nextTick();

    this.panel.group = prevGroup;

    if (updateFlag !== E.EUpdateFlag.Delete) {
      this.panel.item = this.panel.items.findIndex(x => x.code === result.code);
    }

    if (updateFlag === E.EUpdateFlag.Insert) {
      const zones: I.ZoneDetail[] = JSON.parse(JSON.stringify(this.pageInfo.listZone));
      const latest = zones.sort((a, b) => b.code - a.code)?.[0];
      console.log(latest);
      if (latest) {
        const targetIndex = this.panel.items.findIndex(x => x.code === latest.code);
        this.panel.item = targetIndex;
      }
      this.dataItem.state.itemStatus = E.ItemStatus.Update;
      await this.showErrorModal('알림', '추가되었습니다');
    } else if (updateFlag === E.EUpdateFlag.Update) {
      await this.showErrorModal('알림', '수정되었습니다');
    } else if (updateFlag === E.EUpdateFlag.Delete) {
      this.dataItem.state = new State();
      this.panel.item = -1;
      await this.showErrorModal('알림', '삭제되었습니다');
    }
  }

  async onClearClicked() {
    const confirm = await this.showConfirmModal('확인', '입력중인 내용을 취소할까요?', [
      '네',
      '아니오'
    ]);

    if (confirm === 0) {
      this.dataItem.state = new State();
    }
  }

  OnClickAccountInformationFilterSetting(e: Event) {
    console.log(e);
    this.navigate({
      controller: 'Config',
      action: 'AccountInformationFilterSettings',
      groupId: e.groupId
    });
  }

  OnFilterClicked() {
    type FilterlistParams = { title: string; param: I.DataParam };
    const dialogParams = new I.DialogParam<FilterlistParams>('AxAccountFilterDialog', {
      title: '필터 설정',
      param: {
        items: [this.dataItem.state],
        headers: [{ text: '이름', value: 'name', align: 'start' }],
        selected: [this.dataItem.state],
        callback: async () => {
          if (dialogParams.props.param.selected[0].companycodeFilterList) {
            this.dataItem.state.companycodeFilterList =
              dialogParams.props.param.selected[0].companycodeFilterList;
          }
          if (dialogParams.props.param.selected[0].deptcodebFilterList) {
            this.dataItem.state.deptcodebFilterList =
              dialogParams.props.param.selected[0].deptcodebFilterList;
          }
        }
      }
    });
    this.showDialog(dialogParams);
  }

  OnZoneSelectClicked() {
    type ZonelistParams = { title: string; param: I.DataParam };
    const dialogParams = new I.DialogParam<ZonelistParams>('AxAccountZoneSelectDialog', {
      title: '구역 선택',
      param: {
        items: this.getZoneList(),
        headers: [{ text: '이름', value: 'name', align: 'start' }],
        selected: this.dataItem.state.zoneList,
        callback: async () => {
          const selected = dialogParams.props.param.selected as I.ZoneData[];
          this.dataItem.state.zoneList = selected;
        }
      }
    });
    console.log('dialog', dialogParams);
    this.showDialog(dialogParams);
  }

  OnChangePassword() {
    type PasswordParams = { title: string; param: I.DataParam };
    const dialogParams = new I.DialogParam<PasswordParams>('AxAccountChangePasswordDialog', {
      title: '암호 입력',
      param: {
        items: [this.dataItem.state],
        headers: [{ text: '이름', value: 'name', align: 'start' }],
        selected: [this.dataItem.state],
        callback: async () => {
          if (dialogParams.props.param.selected[0].password) {
            this.dataItem.state.password = dialogParams.props.param.selected[0].password;
          }
          console.log('state', this.dataItem.state);
        }
      }
    });
    this.showDialog(dialogParams);
  }

  OnTypeSelectChange() {
    let listIdx: number[] = [];
    if (this.dataItem.state.privType === '10') {
      listIdx = [1, 21, 22, 23, 71, 72, 81, 121, 122];
    } else if (this.dataItem.state.privType === '50') {
      listIdx = [
        1,
        21,
        22,
        23,
        31,
        51,
        61,
        71,
        72,
        75,
        76,
        81,
        91,
        101,
        121,
        122,
        141,
        142,
        143,
        391
      ];
    } else if (this.dataItem.state.privType === '100') {
      listIdx = [
        1,
        21,
        22,
        23,
        31,
        51,
        61,
        71,
        72,
        75,
        76,
        81,
        91,
        101,
        121,
        122,
        141,
        142,
        143,
        151,
        171,
        181,
        191,
        211,
        231,
        241,
        351,
        361,
        371,
        391
      ];
    }
    const selectedAccount1 = this.pageInfo.listMenu.filter((menu, idx, source) =>
      listIdx.includes(menu.idx)
    );
    this.dataItem.state.selected = selectedAccount1;
  }
}
